import { gql } from "@apollo/client";

export const FETCH_SELECTED_IT_APPS = gql`
   query GetSelectedItApplications($data: FilterInput) {
    getSelectedItApplications(data: $data) {
      uuid
      application
      applicationType
      supportsRevenue
      percentage
    }
  }
`;

export const FETCH_LOCATION_SELECTED_IT_APPS = gql`
  query GetSelectedLocationItApplications($data: ID!) {
    getSelectedLocationItApplications(data: $data) {
      uuid
      application
      applicationType
      supportsRevenue
      percentage
    }
  }
`;